/****************************************************************************************
 * File Name    : FinishedProduct.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
        2022.02.14      zena        panes 변수 삭제
****************************************************************************************/
<template>
    <div>
         <a-row :gutter="4">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title = "등록하기" />
                </div>
            </a-col>
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box div_action">
                </div>
            </a-col>
        </a-row>
        <a-divider type = 'horizontal' />
        <p/>
        <div v-if = "isVisibleForTemplate === true" style = 'margin-top:20px;padding:10px 10px 10px 10px;border:0px solid #CCC'>
            <div class = "todo">해당 텝플릿을 클릭하면, '새로작성하기' 의 Step 을 따른다. </div>
            <a-table :columns="columnForTemplate" size = "small" :bordered=false :data-source="data2" :pagination="false" :scroll="{ x: 0, y: '57vh' }">
                <span slot="tags" slot-scope="tag">
                    <a-tag :color="tag === '보류' ? '#CDCDCD' : '#929292'">
                        {{ tag.toUpperCase() }}
                    </a-tag>
                </span>
                <span slot="name" slot-scope="text">{{ text }}</span>
                <span slot="action" slot-scope="record">
                    <span @click="handlerToCreateProductCS(record.key)" style="cursor:pointer;"><a-icon type="edit" /> 템플릿 선택</span>
                </span>
            </a-table>
        </div>
        <div v-else-if = "isVisibleForNew === true" style = 'margin-top:20px;padding:10px 10px 10px 10px;border:0px solid #CCC'>
            <a-row type="flex" justify="center" align="top" >
                <a-col :span="6">
                     <div class = "todo">CS 설정을 단계별로 진행한다</div>
                    <a-steps direction="vertical" :current="step">
                        <a-step title="제품선택" :description="selectedProduct.map(item => item.name).join(', ')" />
                        <a-step title="이미지 등록" :description="createdCSTotal" />
                        <a-step title="완료" description="" />
                    </a-steps>
                    <div style = 'width:100%;text-align:center;margin-top:20px'>
                            <a-divider type = 'horizontal' />
                            <div class = 'todo'>Step 상태에 따라 버튼은 Disable / Enable 어야 한다.</div>
                            <a-button v-if="step > 0" icon="rollback" type = 'danger' :ghost=true @click = "setStepPrev" :disabled=false> 이전 </a-button>
                            <a-divider v-if="step > 0" type = 'vertical' />
                            <a-button v-if="step < 2" icon="check" type = 'primary' :ghost=true @click = "setStepNext"> 다음 </a-button>
                    </div>
                </a-col>
                <a-col :span="18">
                    <div style = 'padding:0px 10px 10px 20px'>
                        <div v-if = "step === 0">
                            <a-input-search v-model="filterProduct" v-on:keyup="filterProductList" placeholder="검색 상품명 / 코드명" style="width: 100%"  />
                            <p/>
                            <a-table :columns="columns" size = "small" :bordered=false :data-source="data" :pagination="false" :scroll="{ x: 0, y: '57vh' }">
                                <span slot="action" slot-scope="record">
                                    <a-switch v-model = "record.checked" checked-children="선택" un-checked-children="취소" @change="handlerForSwitch(record)" />
                                </span>
                                <span slot="tags" slot-scope="tags">
                                    <a-tag v-for="(item,index) in tags" :key='index' :color="index===0 ? '#7F7F7F' : '#5B5B5B'" >
                                        {{ item.toUpperCase() }}
                                    </a-tag>
                                </span>
                                <span slot="name" slot-scope="text">{{ text }}</span>
                                <span slot="image" slot-scope="image">
                                    <img :src = "image" width=25/>
                                </span>
                            </a-table>
                        </div>
                        <div v-if = "step === 1">
                            <a-row type="flex" justify="center" align="top" :gutter="16">
                                <a-col :span="24" style = 'padding-left:20px'>
                                    <div style = 'height:60vh;overflow:auto;'>
                                        <a-form-item label="제품이미지" class="error-create-form-item">
                                            <img v-if="image" :src = "image" style="width:100px;">
                                            <a-upload name="file" :multiple="false" :action="$store.state.imageUploadServer" @change="imageUpload"
                                                v-decorator="['ele07',{rules: [{ required: false, message: '제품이미지를 선택하세요' }],},]">
                                                <a-button> <a-icon type="camera" /> 이미지 선택 </a-button>
                                            </a-upload>
                                            <br /><br />
                                            <div v-html="inspectionImageList"></div>
                                        </a-form-item>
                                    </div>
                                </a-col>
                            </a-row>
                        </div>
                        <div v-if = "step === 2">
                            <div class = 'todo'>설정된 CS의 검사시간을 설정한다.</div>
                            <!-- <ModalSetTime /> -->
                            <div style = 'text-align:center;margin-top:50px'>
                                <!-- <div class = 'todo'>'입력내용지우기' 클릭시 입력내용을 지우고, 처음으로, '임시저장' 보류상태로 저장</div>
                                <a-button icon="rollback" type = 'danger' :ghost=true> 입력내용지우기 </a-button>
                                <a-divider type = 'vertical' /> -->
                                <a-button icon="check" type = 'primary' :ghost=true @click="handlerToSaveCSForProudct()"> 완료 </a-button>
                            </div>
                        </div>
                    </div>
                </a-col>
            </a-row>
        </div>
        <a-divider type = 'horizontal' />
    </div>
</template>
<script>
import _ from "lodash";
import $ from "jquery";
import PageHeader from "../components/PageHeader.vue" ;

const MAX_STEP = 2;
const MIN_STEP = 0;
// TODO : 제품테이블은 공통모듈화 해야함.
const columns = [
    { title: '선택',key: 'action',scopedSlots: { customRender: 'action'},  width : 100},
    { title: 'image',dataIndex: 'image',key: 'image',  scopedSlots: { customRender: 'image'},  width : 150},
    { title: '모델명',dataIndex: 'model',key: 'model',  scopedSlots: { customRender: 'model'},},
    { title: '세부모델명',dataIndex: 'modelDetail',key: 'modelDetail',  scopedSlots: { customRender: 'modelDetail'},},
    { title: '제품명',dataIndex: 'name',key: 'name',  scopedSlots: { customRender: 'name'},},
    { title: 'POP',dataIndex: 'pop',key: 'pop',  scopedSlots: { customRender: 'pop'},},
    { title: 'SAP',dataIndex: 'sap',key: 'sap',  scopedSlots: { customRender: 'sap'},},

];
const data = [];
const columnForTemplate = [
    {    title: '모델명' , dataIndex: 'model' , key: 'model' , scopedSlots: { customRender: 'model' },},
    {    title: '세부모델명' , dataIndex: 'modelDetail' , key: 'modelDetail' , scopedSlots: { customRender: 'modelDetail' },},
    {    title: '제품명' , dataIndex: 'product' , key: 'product' , scopedSlots: { customRender: 'name' },},
    {    title: '최종수정일' , dataIndex: 'updated' , key: 'updated' , scopedSlots: { customRender: 'name' },},
    {    title: '관리' , key: 'action' , scopedSlots: { customRender: 'action' }, width : 250},
];

export default {
    name: 'ErrorCreate',
    components: {
        PageHeader,
        // ModalSetTime,
        //BaseInput,

    },
    data() {
        //const panes = [{ title: '검사대상 1', content: '', key: '1' , order: 1, child : []},];
        return {
            cInspectionTargetTitle       : '검사대상',
            MAX_STEP                    ,
            MIN_STEP                    ,
            step                        : 0,
            data                        ,
            dataBackup                  : [],
            data2Backup                 : [],
            columns                     ,
            columnForTemplate           ,
            selectedProduct             : [],
            fileUploadSeq               : '',
            uploadFileSeq               : [],
            inspectionImageList         : '',
            //itemTotal                   : 1,
            //panes                       ,
            activeKey                   : 0,
            //newTabIndex                 : 1,
            keyForTab                   : 0,
            flagForSpinner              : false,
            isVisibleForNew             : true,
            isVisibleForTemplate        : false,
            //isSelectProduct             : false,
            //isVisibleForModalSetTime    : false,
            currentPage                 : 0,
            editCS                      : this.$route.params && this.$route.params.editCS,
            listTarget                  : [],
            data2                       : [],
            dataArray2                  : [],
            createFromTemplate          : false,
            filterProduct               : '',
            reRenderKey                 : 0,
            fileDelimiter: '||',
            seq: this.$route.params.seq,
        };
    },
    computed : {
        createdCSTotal() {
            return '';
        }
    },
    mounted() {
        this.flagForSpinner = false;

        // 수정인 경우
        if (this.$route.params && this.$route.params.seq) {
            let url = this.$store.state.nodeApiUrl + '/focus/focusitem/' + this.seq;
            this.$http.get(url)
            .then((response) => {
                if(response.status === 200 && response.data) {
                    let productSeqList = response.data['PRODUCT_SEQ_LIST'].split(this.fileDelimiter).map(item => {
                        return +item;
                    });

                    this.loadProductList(productSeqList);

                    let uploadFileSeqList = response.data['UPLOAD_FILE_SEQ_LIST'] ? response.data['UPLOAD_FILE_SEQ_LIST'].split(this.fileDelimiter).map(item => {
                        return +item;
                    }) : [];
                    this.uploadFileSeq = uploadFileSeqList;

                    this.fileUploadSeq = response.data['UPLOAD_FILE_SEQ_LIST'];

                    let self = this;

                    let html = '';
                    
                    _.forEach(uploadFileSeqList, (item) => {
                        let src = self.$store.state.hostInService +'/upload/image/download/' + item;
                        html += '<p><a href = "' + src + '" target="_blank"><img src = "' + src + '" style = "height:100px; vertical-align:bottom;"/></a> <span id="delete-image-focusmanagement-' + item + '" style="font-size:12px; cursor:pointer;">삭제</span></p>';

                        ((self) => {
                            $('body').off('click.delete-image-focusmanagement-' + item).on('click.delete-image-focusmanagement-' + item, '#delete-image-focusmanagement-' + item , function() {
                                if (confirm('삭제하시겠습니까?')) {
                                    self.uploadFileSeq.splice(self.uploadFileSeq.indexOf('' + item), 1);
                                    self.fileUploadSeq = self.uploadFileSeq.join(this.fileDelimiter);
                                    
                                    html = '';
                                    _.forEach(self.uploadFileSeq, (item) => {
                                        let src = self.$store.state.hostInService +'/upload/image/download/' + item;
                                        html += '<p style="margin-bottom:20px;"><a href = "' + src + '" target="_blank"><img src = "' + src + '" style = "height:100px; vertical-align:bottom;"/></a> <span id="delete-image-focusmanagement' + item + '" style="font-size:12px; cursor:pointer;">삭제</span></p>';
                                    });

                                    self.inspectionImageList = html;
                                }
                            });
                        })(self);
                    });

                    self.inspectionImageList = html;
                }
            })
            .catch((error) => {
                console.error(error);
            });
        } else {
            this.loadProductList();
        }
    },
    methods : {
        loadProductList(productSeqList) {
            this.data = [];
            this.flagForSpinner = true;
            let urlForProduct = this.$store.state.nodeApiUrl + '/product/list?size=1000&page=' + this.currentPage;
            this.$http.get(urlForProduct)
            .then((response) => {
                // 전체자료수 :
                let data = response.data.data;
                console.log("전체자료수 : " + data.totalElements);
                console.log("전체페이지수 : " + data.totalPages);
                console.log("현재페이지 :  " + data.number);
                console.log("현재자료수 :  " + data.numberOfElements);
                console.log(data.content[0]);
                if(response.status === 200 && response.data.code === 'success') {

                    let dataArray = response.data.data.content;
                    dataArray = dataArray.reverse();    // 최종생성된 것이 위로 가도록 정렬
                    for(let x = 0; x < dataArray.length; x ++ ) {
                        let type;

                        // WATER: 정수기, AIR: 청정기, ETC: 기타기기
                        let temp = _.find(dataArray[x].listProductType, {
                            productTypeName: 'WATER'
                        });
                        if (temp) {
                            type = 'WATER';
                        } else {
                            let temp2 = _.find(dataArray[x].listProductType, {
                                productTypeName: 'AIR'
                            });
                            if (temp2) {
                                type = 'AIR';
                            } else {
                                let temp3 = _.find(dataArray[x].listProductType, {
                                    productTypeName: 'ETC'
                                });
                                if (temp3) {
                                    type = 'ETC';
                                }
                            }
                        }

                        if (type === 'WATER' || type === 'AIR' || type === 'ETC') {
                            let element = {
                                key : x,
                                seq : dataArray[x].productSeq,
                                name : dataArray[x].productName,
                                model : dataArray[x].productModel,
                                modelDetail : dataArray[x].productModelDetail,
                                tags : [dataArray[x].productPop,dataArray[x].productSap],
                                pop: dataArray[x].productPop,
                                sap: dataArray[x].productSap,
                                checked : false,
                                image : this.$store.state.hostInService + '/upload/image/download/' + dataArray[x].uploadFileSeq,
                            }

                            // CS 수정인 경우
                            if (productSeqList && productSeqList.indexOf(element.seq) > -1) {
                                // 생성할 때 선택하였던 제품이 선택되어 있도록
                                element.checked = true;
                                this.selectedProduct.push(element);
                            }

                            this.data.push(element);
                            this.dataBackup = JSON.parse(JSON.stringify(this.data));
                        }
                    }
                }
            })
            .catch(error => {
                console.error(error);
            });
        },
        setStepNext() {
            if(this.step < this.MAX_STEP) {
                this.step ++;
            }
        },
        setStepPrev() {
            if(this.step > this.MIN_STEP) {
                this.step --;
            }
        },
        handlerForSwitch(item) {
            let checkedItem = _.find(this.data, {
                seq: item.seq
            });
            
            if (item.checked) {
                checkedItem.checked = true;
                this.selectedProduct.push(checkedItem);
            } else {
                checkedItem.checked = false;
                this.selectedProduct = _.filter(this.selectedProduct, (item) => {
                    return item.seq !== checkedItem.seq;
                });
            }

            // 중복 제품 제거
            this.selectedProduct = _.uniqBy(this.selectedProduct, 'seq');
        },
        handlerToSaveCSForProudct() {
            let productSeqList = this.selectedProduct.map(item => item.seq);
            productSeqList = productSeqList.join(this.fileDelimiter);

            let formData = {
                PRODUCT_SEQ_LIST : productSeqList,
                UPLOAD_FILE_SEQ_LIST : this.fileUploadSeq,
            }

            // 수정인 경우
            if (this.seq) {
                let url = this.$store.state.nodeApiUrl + '/focus/focusupdate/' + this.seq;
                this.$http.put(url,formData)
                    .then((response) => {
                        console.log(response);
                        this.$message.success('저장되었습니다');
                        location = '#/errorList';
                    })
                    .catch(error => {
                        console.log(error);
                    });
            } else {
                let url = this.$store.state.nodeApiUrl + '/focus/focuscreate';
                this.$http.post(url,formData)
                    .then((response) => {
                        console.log(response);
                        this.$message.success('저장되었습니다');
                        location = '#/errorList';
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        filterProductList() {
            if (this.filterProduct) {
                let re = new RegExp(this.filterProduct, 'gi');

                this.data = _.filter(this.dataBackup, (item) => {
                    return item.model && item.model.match(re) || item.modelDetail && item.modelDetail.match(re) || item.name && item.name.match(re);
                });
            } else {
                this.data = this.dataBackup;
            }
        },
        imageUpload(info) {
            this.spinning = info.file.status === 'uploading' ? true : false;
            if(info.file.status === 'done') {
                let files = this.fileUploadSeq.split(this.fileDelimiter);
                files = _.filter(files, (seq) => {
                    return seq;
                });
                this.$message.success(`${info.file.name} file uploaded successfully`);
                files.push(info.file.response.data.uploadFileSeq);
                this.fileUploadSeq = files.join(this.fileDelimiter);
                
                // 이미지 리사이징 API 호출
                this.$http.post(`${this.$store.state.nodeApiUrl}/user/resize-image`, {
                    uploadFileSeq: info.file.response.data.uploadFileSeq
                })
                .then(response => {
                    if (response.data.code === 'success') {
                        console.log('✅ Image resized:', response.data.data);
                    }
                })
                .catch(error => {
                    console.error('❌ Resize failed:', error);
                });
            } else if(info.file.status === 'error') {
                this.$message.error(`${info.file.name} file upload failed.`);
            }
        }
    }
}
</script>
<style scoped>
    .div_selected_product {
        margin-top : 30px;
    }
</style>